import ApiService from '@/core/api/api.service';

export default class MosEmailSettingsServices extends ApiService {
  async fetch() {
    this.url = 'cr/memorandum/memorandum_notify/settings';
    const { result: { data } } = await this.get();
    return data;
  }
}
